import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Nick
 * id A66B4E6E-70F9-4136-BE33-D02C002F7B30
 * name water-pump-off
 * version: 3.9.97
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/water-pump-off.svg
 * tags
 * - Agriculture 
 * - Home Automation 
 */
export const WaterPumpOffIcon = createSvgIcon(<><path d="M5.7 2.5A2 2 0 0 1 7 2H9A2 2 0 0 1 11 4V5H19A2 2 0 0 1 21 7V11A1 1 0 0 1 21 13H17A1 1 0 0 1 17 11V9H12.2M20.84 22.73L22.11 21.46L11 10.34L2.39 1.73L1.11 3L3.65 5.54A2 2 0 0 0 5 9V18H4A2 2 0 0 0 2 20V22H14V20A2 2 0 0 0 12 18H11V12.89Z" /></>, 'WaterPumpOffIcon');
export default WaterPumpOffIcon